// Prefetch the JS chunks for the sections people click after Home.
// Idle: download while they read the dashboard. Hover: download if idle missed.

const LOADERS = {
  agents: () => import('../pages/Agents'),
  crm: () => import('../pages/CRM'),
  referrals: () => import('../pages/Referrals'),
  calendar: () => import('../pages/CalendarPage'),
  listings: () => import('../pages/ListingManagement'),
  revenue: () => import('../pages/Sales'),
  vault: () => import('../pages/Vault'),
  settings: () => import('../pages/Settings'),
  academy: () => import('../pages/IpmAcademy'),
};

const _started = new Set();

export function prefetchNavChunk(navId) {
  const load = LOADERS[navId];
  if (!load || _started.has(navId)) return;
  _started.add(navId);
  load().catch(() => { _started.delete(navId); });
}

export function scheduleIdleRoutePrefetch() {
  if (typeof window === 'undefined') return;
  const run = () => {
    ['crm', 'listings', 'revenue', 'agents', 'calendar', 'vault'].forEach((id, i) => {
      setTimeout(() => prefetchNavChunk(id), i * 120);
    });
  };
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(run, { timeout: 2500 });
  } else {
    setTimeout(run, 600);
  }
}
